import React, { memo } from 'react';

import { translate } from 'services/i18nService';

import style from './index.css';


const EventNotification = () => (
  <div className={style.message}>
    <div className={style.title}>
      {translate('v2profile.naked.and.uncut.hedonism')}
    </div>
    <div className={style.text}>
      {translate('v2profile.naked.and.uncut.body')}
    </div>
  </div>
);

export default memo(EventNotification);
